import { Route } from "react-router";
import UserSettingsPage from "pages/Preferences/UserSettings/UserSettingsPage";
import AdminSettingsPage from "pages/Preferences/AdminSettings/AdminSettingsPage";
import PeopleSettingsPage from "pages/Preferences/People/PeopleSettingsPage";
import PersonSettingsPage from "pages/Preferences/People/PersonSettingsPage";
import AllAccountSettingsPage from "pages/Preferences/Accounts/AllAccountSettingsPage";
import BillToSettingsPage from "pages/Preferences/BillToSettings/BillToSettingsPage";
import AccountBillToPage from "pages/Preferences/Accounts/AccountBillToPage/AccountBillToPage.tsx";
import AllStoresAdminPage from "pages/Preferences/Stores/AllStoresAdminPage.tsx";
import StoreSettingsPage from "pages/Preferences/Stores/StoreSettingsPage.tsx";

export const UserPreferencesRoutes = (
	<>
		<Route
			path="user-settings"
			element={<UserSettingsPage />}
		/>
		<Route path="admin-settings">
			<Route
				index
				element={<AdminSettingsPage />}
			/>
			<Route path="people">
				<Route
					index
					element={<PeopleSettingsPage />}
				/>
				<Route
					path=":userId"
					element={<PersonSettingsPage />}
				/>
			</Route>
			<Route path="accounts">
				<Route
					index
					element={<AllAccountSettingsPage />}
				/>
				<Route path=":accountId/billTos">
					<Route
						index
						element={<AccountBillToPage />}
					/>
					<Route
						path=":billToId"
						element={<BillToSettingsPage />}
					/>
				</Route>
			</Route>
			<Route path="stores">
				<Route
					index
					element={<AllStoresAdminPage />}
				/>
				<Route
					path=":storeId"
					element={<StoreSettingsPage />}
				/>
			</Route>
		</Route>
	</>
);
